import { render, staticRenderFns } from "./cardPropertySetting.vue?vue&type=template&id=fad86fc4&"
import script from "./cardPropertySetting.vue?vue&type=script&lang=js&"
export * from "./cardPropertySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports